export type SponsorType = 'local' | 'regional' | 'nacional';
export type SponsorStatus = 'activo' | 'inactivo' | 'pendiente';

export interface SponsorCampaign {
  id: number;
  name: string;
  startDate: string;
  endDate: string;
  investment: number;
  status: 'activo' | 'finalizado' | 'programado';
  radioName: string;
  radioFrequency: string;
}

export interface SponsorHistoryEntry {
  id: number;
  action: string;
  date: string;
  description: string;
  amount?: number;
}

export interface Sponsor {
  id: number;
  companyName: string;
  type: SponsorType;
  totalCampaigns: number;
  activeRadios: number;
  totalInvestment: number;
  status: SponsorStatus;
  sector: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  city: string;
  country: string;
  joinedDate: string;
  campaigns: SponsorCampaign[];
  history: SponsorHistoryEntry[];
}

export const sponsors: Sponsor[] = [
  {
    id: 1,
    companyName: 'Banco Santander',
    type: 'nacional',
    totalCampaigns: 8,
    activeRadios: 5,
    totalInvestment: 285000,
    status: 'activo',
    sector: 'Financiero',
    contactName: 'Carlos Mendoza',
    contactEmail: 'cmendoza@santander.com.mx',
    contactPhone: '+52 55 1234 5678',
    city: 'Ciudad de México',
    country: 'México',
    joinedDate: '2025-03-15',
    campaigns: [
      { id: 101, name: 'Cuenta Digital 2026', startDate: '2026-01-01', endDate: '2026-06-30', investment: 45000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
      { id: 102, name: 'Crédito Hipotecario', startDate: '2026-02-15', endDate: '2026-08-15', investment: 52000, status: 'activo', radioName: 'Radio Industria', radioFrequency: '93.5 FM' },
      { id: 103, name: 'Tarjeta Oro', startDate: '2026-04-01', endDate: '2026-10-01', investment: 38000, status: 'activo', radioName: 'Estéreo Capital', radioFrequency: '102.1 FM' },
      { id: 104, name: 'Seguro Auto', startDate: '2025-09-01', endDate: '2026-03-01', investment: 35000, status: 'finalizado', radioName: 'Radio Costa Azul', radioFrequency: '88.7 FM' },
      { id: 105, name: 'Inversiones Premium', startDate: '2026-05-01', endDate: '2026-11-01', investment: 60000, status: 'activo', radioName: 'Radio Élite Digital', radioFrequency: '99.1 FM' },
    ],
    history: [
      { id: 1001, action: 'Registro', date: '2025-03-15', description: 'Primer contacto y registro como patrocinador nacional.' },
      { id: 1002, action: 'Primera Campaña', date: '2025-04-01', description: 'Lanzamiento de campaña piloto con Radio Éxito FM.', amount: 12000 },
      { id: 1003, action: 'Expansión', date: '2025-09-01', description: 'Ampliación a 3 radios simultáneas.', amount: 85000 },
      { id: 1004, action: 'Renovación Anual', date: '2026-01-15', description: 'Renovación de contrato marco con RFW por 12 meses.', amount: 120000 },
    ],
  },
  {
    id: 2,
    companyName: 'AutoLux Premium',
    type: 'regional',
    totalCampaigns: 5,
    activeRadios: 3,
    totalInvestment: 180000,
    status: 'activo',
    sector: 'Automotriz',
    contactName: 'María Fernanda López',
    contactEmail: 'mflopez@autolux.mx',
    contactPhone: '+52 81 2345 6789',
    city: 'Monterrey',
    country: 'México',
    joinedDate: '2025-06-10',
    campaigns: [
      { id: 201, name: 'AutoShow Monterrey 2026', startDate: '2026-06-15', endDate: '2026-09-15', investment: 41000, status: 'activo', radioName: 'Radio Industria', radioFrequency: '93.5 FM' },
      { id: 202, name: 'Lanzamiento SUV 2026', startDate: '2026-03-01', endDate: '2026-07-01', investment: 55000, status: 'activo', radioName: 'Radio Deportiva Total', radioFrequency: '95.7 FM' },
      { id: 203, name: 'Test Drive Weekend', startDate: '2026-01-15', endDate: '2026-04-15', investment: 28000, status: 'finalizado', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
    ],
    history: [
      { id: 2001, action: 'Registro', date: '2025-06-10', description: 'Alta como patrocinador regional zona norte.' },
      { id: 2002, action: 'Campaña Inaugural', date: '2025-07-01', description: 'Primera campaña regional con Radio Industria.', amount: 25000 },
      { id: 2003, action: 'Upgrade', date: '2026-01-01', description: 'Ampliación de presupuesto publicitario regional.', amount: 80000 },
    ],
  },
  {
    id: 3,
    companyName: 'Restaurante La Parrilla del Centro',
    type: 'local',
    totalCampaigns: 3,
    activeRadios: 1,
    totalInvestment: 24000,
    status: 'activo',
    sector: 'Gastronomía',
    contactName: 'José Ramírez',
    contactEmail: 'jramirez@laparrilla.mx',
    contactPhone: '+52 55 9876 5432',
    city: 'Ciudad de México',
    country: 'México',
    joinedDate: '2026-01-20',
    campaigns: [
      { id: 301, name: 'Menú Ejecutivo CDMX', startDate: '2026-03-01', endDate: '2026-08-01', investment: 12000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
    ],
    history: [
      { id: 3001, action: 'Registro', date: '2026-01-20', description: 'Alta como patrocinador local CDMX.' },
      { id: 3002, action: 'Campaña Lanzamiento', date: '2026-03-01', description: 'Primera campaña local: Menú Ejecutivo.', amount: 12000 },
    ],
  },
  {
    id: 4,
    companyName: 'Gimnasio PowerFit',
    type: 'regional',
    totalCampaigns: 6,
    activeRadios: 4,
    totalInvestment: 148000,
    status: 'activo',
    sector: 'Salud y Fitness',
    contactName: 'Andrea Castillo',
    contactEmail: 'acastillo@powerfit.mx',
    contactPhone: '+52 33 3456 7890',
    city: 'Guadalajara',
    country: 'México',
    joinedDate: '2025-08-05',
    campaigns: [
      { id: 401, name: 'Fitness Total Promo', startDate: '2026-05-01', endDate: '2026-08-01', investment: 22000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
      { id: 402, name: 'Verano PowerFit', startDate: '2026-06-01', endDate: '2026-09-01', investment: 30000, status: 'activo', radioName: 'Radio Deportiva Total', radioFrequency: '95.7 FM' },
      { id: 403, name: 'Reto 30 Días', startDate: '2026-02-01', endDate: '2026-05-01', investment: 18000, status: 'finalizado', radioName: 'Radio Estéreo Capital', radioFrequency: '102.1 FM' },
    ],
    history: [
      { id: 4001, action: 'Registro', date: '2025-08-05', description: 'Alta como patrocinador regional zona occidente.' },
      { id: 4002, action: 'Expansión Regional', date: '2026-01-01', description: 'Ampliación de cobertura a 4 radios en 3 ciudades.', amount: 60000 },
    ],
  },
  {
    id: 5,
    companyName: 'TechNova Solutions',
    type: 'nacional',
    totalCampaigns: 10,
    activeRadios: 6,
    totalInvestment: 420000,
    status: 'activo',
    sector: 'Tecnología',
    contactName: 'Roberto Fuentes',
    contactEmail: 'rfuentes@technova.mx',
    contactPhone: '+52 81 4567 8901',
    city: 'Monterrey',
    country: 'México',
    joinedDate: '2025-01-10',
    campaigns: [
      { id: 501, name: 'Tecnología Verde Promo', startDate: '2026-05-15', endDate: '2026-08-15', investment: 38000, status: 'activo', radioName: 'Radio Industria', radioFrequency: '93.5 FM' },
      { id: 502, name: 'Cloud Empresarial 2026', startDate: '2026-03-01', endDate: '2026-09-01', investment: 65000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
      { id: 503, name: 'Ciberseguridad PYME', startDate: '2026-01-15', endDate: '2026-07-15', investment: 48000, status: 'activo', radioName: 'Radio Élite Digital', radioFrequency: '99.1 FM' },
      { id: 504, name: 'IoT para Negocios', startDate: '2025-09-01', endDate: '2026-02-01', investment: 42000, status: 'finalizado', radioName: 'Estéreo Capital', radioFrequency: '102.1 FM' },
    ],
    history: [
      { id: 5001, action: 'Registro', date: '2025-01-10', description: 'Alta como patrocinador nacional premium.' },
      { id: 5002, action: 'Contrato Marco', date: '2025-02-01', description: 'Firma de contrato anual con 5 radios.', amount: 200000 },
      { id: 5003, action: 'Expansión 6 Radios', date: '2026-01-01', description: 'Ampliación a 6 radios + presupuesto incrementado.', amount: 220000 },
    ],
  },
  {
    id: 6,
    companyName: 'Hotel Brisas del Pacífico',
    type: 'regional',
    totalCampaigns: 4,
    activeRadios: 2,
    totalInvestment: 95000,
    status: 'activo',
    sector: 'Turismo',
    contactName: 'Daniela Vargas',
    contactEmail: 'dvargas@hotelbrisas.com',
    contactPhone: '+506 2222 3333',
    city: 'San José',
    country: 'Costa Rica',
    joinedDate: '2025-11-20',
    campaigns: [
      { id: 601, name: 'Hotel Brisas Turismo Premium', startDate: '2026-03-15', endDate: '2026-06-15', investment: 25000, status: 'activo', radioName: 'Radio Costa Azul', radioFrequency: '88.7 FM' },
      { id: 602, name: 'Escapada de Fin de Semana', startDate: '2026-05-01', endDate: '2026-09-01', investment: 20000, status: 'activo', radioName: 'Radio Peninsular', radioFrequency: '101.9 FM' },
    ],
    history: [
      { id: 6001, action: 'Registro', date: '2025-11-20', description: 'Alta como patrocinador regional Costa Rica.' },
      { id: 6002, action: 'Campaña Premium', date: '2026-03-15', description: 'Lanzamiento campaña turismo premium.', amount: 25000 },
    ],
  },
  {
    id: 7,
    companyName: 'Panadería El Buen Sabor',
    type: 'local',
    totalCampaigns: 2,
    activeRadios: 1,
    totalInvestment: 8500,
    status: 'activo',
    sector: 'Alimentación',
    contactName: 'Rosa Martínez',
    contactEmail: 'rosa@elbuensabor.mx',
    contactPhone: '+52 999 111 2233',
    city: 'Mérida',
    country: 'México',
    joinedDate: '2026-04-01',
    campaigns: [
      { id: 701, name: 'Pan Fresco Mañanero', startDate: '2026-04-15', endDate: '2026-08-15', investment: 5000, status: 'activo', radioName: 'Radio Peninsular', radioFrequency: '101.9 FM' },
    ],
    history: [
      { id: 7001, action: 'Registro', date: '2026-04-01', description: 'Alta como patrocinador local Mérida.' },
      { id: 7002, action: 'Campaña Lanzamiento', date: '2026-04-15', description: 'Primera campaña radial local.', amount: 5000 },
    ],
  },
  {
    id: 8,
    companyName: 'Universidad Virtual',
    type: 'nacional',
    totalCampaigns: 7,
    activeRadios: 4,
    totalInvestment: 210000,
    status: 'activo',
    sector: 'Educación',
    contactName: 'Dr. Miguel Ángel Torres',
    contactEmail: 'mtorres@uvirtual.edu.mx',
    contactPhone: '+52 55 5555 6666',
    city: 'Buenos Aires',
    country: 'Argentina',
    joinedDate: '2025-05-01',
    campaigns: [
      { id: 801, name: 'Patrocinio Educativo Universitario', startDate: '2026-03-01', endDate: '2026-09-01', investment: 28000, status: 'activo', radioName: 'Radio Cultura Digital', radioFrequency: '91.3 FM' },
      { id: 802, name: 'Maestrías Online 2026', startDate: '2026-01-01', endDate: '2026-07-01', investment: 35000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
      { id: 803, name: 'Becas Talento', startDate: '2026-06-01', endDate: '2026-12-01', investment: 42000, status: 'activo', radioName: 'Radio Élite Digital', radioFrequency: '99.1 FM' },
    ],
    history: [
      { id: 8001, action: 'Registro', date: '2025-05-01', description: 'Alta como patrocinador nacional educativo.' },
      { id: 8002, action: 'Contrato Marco', date: '2025-06-01', description: 'Firma de contrato anual con presencia en 4 países.', amount: 150000 },
      { id: 8003, action: 'Expansión Becas', date: '2026-06-01', description: 'Nueva línea de campaña: Becas Talento.', amount: 42000 },
    ],
  },
  {
    id: 9,
    companyName: 'Ferretería Don Pepe',
    type: 'local',
    totalCampaigns: 1,
    activeRadios: 1,
    totalInvestment: 4500,
    status: 'pendiente',
    sector: 'Comercio',
    contactName: 'José Pepe Hernández',
    contactEmail: 'donpepe@ferreteria.mx',
    contactPhone: '+52 686 222 3344',
    city: 'Mexicali',
    country: 'México',
    joinedDate: '2026-06-01',
    campaigns: [],
    history: [
      { id: 9001, action: 'Registro', date: '2026-06-01', description: 'Solicitud de alta como patrocinador local.' },
    ],
  },
  {
    id: 10,
    companyName: 'Festival de la Cumbia',
    type: 'regional',
    totalCampaigns: 3,
    activeRadios: 2,
    totalInvestment: 78000,
    status: 'activo',
    sector: 'Entretenimiento',
    contactName: 'Lucía Sánchez',
    contactEmail: 'lsanchez@festivalcumbia.com',
    contactPhone: '+57 4 333 4455',
    city: 'Medellín',
    country: 'Colombia',
    joinedDate: '2025-09-15',
    campaigns: [
      { id: 1001, name: 'Festival Cumbia 2026', startDate: '2026-05-15', endDate: '2026-08-15', investment: 32000, status: 'activo', radioName: 'Radio Estéreo Capital', radioFrequency: '102.1 FM' },
      { id: 1002, name: 'Artistas Revelación', startDate: '2026-04-01', endDate: '2026-07-01', investment: 18000, status: 'activo', radioName: 'Radio Éxito FM', radioFrequency: '98.5 FM' },
    ],
    history: [
      { id: 10001, action: 'Registro', date: '2025-09-15', description: 'Alta como patrocinador regional Colombia.' },
      { id: 10002, action: 'Campaña Festival', date: '2026-05-15', description: 'Lanzamiento campaña principal del festival.', amount: 32000 },
    ],
  },
  {
    id: 11,
    companyName: 'Clínica Dental Sonrisa',
    type: 'local',
    totalCampaigns: 2,
    activeRadios: 1,
    totalInvestment: 12000,
    status: 'inactivo',
    sector: 'Salud',
    contactName: 'Dra. Patricia Rojas',
    contactEmail: 'projas@clinicasonrisa.mx',
    contactPhone: '+52 33 777 8899',
    city: 'Guadalajara',
    country: 'México',
    joinedDate: '2025-07-01',
    campaigns: [
      { id: 1101, name: 'Blanqueamiento Promo', startDate: '2025-09-01', endDate: '2025-12-01', investment: 7000, status: 'finalizado', radioName: 'Radio Deportiva Total', radioFrequency: '95.7 FM' },
    ],
    history: [
      { id: 11001, action: 'Registro', date: '2025-07-01', description: 'Alta como patrocinador local Guadalajara.' },
      { id: 11002, action: 'Campaña Dental', date: '2025-09-01', description: 'Campaña de blanqueamiento temporal.', amount: 7000 },
      { id: 11003, action: 'Pausa', date: '2026-01-01', description: 'Patrocinador pausado por decisión del cliente.' },
    ],
  },
  {
    id: 12,
    companyName: 'Librería El Ateneo',
    type: 'regional',
    totalCampaigns: 4,
    activeRadios: 3,
    totalInvestment: 62000,
    status: 'activo',
    sector: 'Cultura',
    contactName: 'Gabriel Ochoa',
    contactEmail: 'gochoa@elateneo.com',
    contactPhone: '+54 11 4444 5555',
    city: 'Buenos Aires',
    country: 'Argentina',
    joinedDate: '2026-02-10',
    campaigns: [
      { id: 1201, name: 'Feria del Libro Cultural', startDate: '2026-06-01', endDate: '2026-07-15', investment: 15000, status: 'activo', radioName: 'Radio Cultura Digital', radioFrequency: '91.3 FM' },
      { id: 1202, name: 'Club de Lectura', startDate: '2026-03-01', endDate: '2026-09-01', investment: 12000, status: 'activo', radioName: 'Radio Élite Digital', radioFrequency: '99.1 FM' },
    ],
    history: [
      { id: 12001, action: 'Registro', date: '2026-02-10', description: 'Alta como patrocinador regional Argentina.' },
      { id: 12002, action: 'Lanzamiento Dual', date: '2026-03-01', description: 'Dos campañas simultáneas: Feria + Club Lectura.', amount: 27000 },
    ],
  },
];

export const sponsorMetrics = {
  totalSponsors: 12,
  activeSponsors: 10,
  totalInvestment: 1530000,
  totalCampaigns: 55,
  activeRadios: 8,
  avgInvestmentPerSponsor: 127500,
  byType: {
    local: { count: 4, totalInvestment: 49000 },
    regional: { count: 5, totalInvestment: 563000 },
    nacional: { count: 3, totalInvestment: 918000 },
  },
};